import React from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Link} from 'react-router-dom';


const MakerSpace = () =>{
  
  return (
    <div className="LearningSpace">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/innerbanner/explore.jpg"} alt="Explore Library" />
      </section>
      <section className='information-common' id="ExploreLibrary">
        <div className='container'>
          <div className='information-content'>
            <h2>Explore Library</h2>
            <p>The following collaborative spaces are available at the library.</p>
          </div>
          <Row>
                <Col lg={5} sm={6}>
                <div className="floating-Side-wrap">
                    <div className="floating-Side">
                        <div className="right-tab-collab">
                        <div className="flex-column nav nav-pills">
                                <div className="nav-item">
                                    <Link as={Link} to="/collaborative-working-and-learning-spaces" className='nav-link'>
                                    Collaborative Working and Learning Spaces
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/computer-and-technology" className='nav-link'>
                                    Computer And Technology
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/printing-scanning-and-photocopying" className='nav-link'>
                                    Printing Scanning And Photocopying
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/library-service" className='nav-link active'>
                                    Library Service
                                    </Link>
                                </div>
                                <div className="nav-item">
                                    <Link as={Link} to="/maker-space" className='nav-link '>
                                    Maker Space
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Col>
                <Col lg={7} sm={6}>
                <div className="collaboration-hover">
                    <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/img/learningspaces/library-space.jpg"} alt="" />
                    <p>Habib University’s library team aims to provide students with adequate facilities for learning with passion. With a range of library and learning services available, it creates an environment that supports teaching, learning, and research. The library provides a stimulating user-centered environment, learning spaces, and customer services supported by digital technologies.</p>
                    <Link as={Link} to="/library-services" className='btn-dfault'>
                    View All Library Services
                                    </Link>
                </div>
                </Col>
            </Row>
        </div>
      </section>


    </div>
  );
}
export default MakerSpace;